import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { checkoutInvoice } from "../../../../../../store/checkoutInvoice";
import PaymentFormModal from "./components/PaymentFormModal";

const ApplyGiftAmount = ({ giftCard, isTipsApplying }) => {
  const availableAmount = giftCard?.availableAmount || 0;

  return (
    <div>
      <PaymentFormModal
        availableAmount={availableAmount}
        isTipsApplying={isTipsApplying}
        giftCard={giftCard}
      />
    </div>
  );
};

ApplyGiftAmount.propTypes = {
  giftCard: PropTypes.shape({
    id: PropTypes.number.isRequired,
    availableAmount: PropTypes.number.isRequired,
    redemptionCode: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = (state) => ({
  isTipsApplying: checkoutInvoice.selectors.selectIsTipsApplying(state),
});

export default connect(mapStateToProps)(ApplyGiftAmount);
